module.exports = __webpack_public_path__ + "img/rowB3.a0ac180e.png";